// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClockCounterIcon } from '@moia-dev/pace-icons'
import { FleetTracingRedirectAreaRoutes } from './FleetTracingRedirectAreaRoutes'

export const FleetTracingRedirectAreaNavigationIcon = ClockCounterIcon

export const FleetTracingRedirectAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetTracingRedirectAreaRoutes.route}
      Icon={FleetTracingRedirectAreaNavigationIcon}
    />
  )
}
